"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.logSpanEnd = logSpanEnd;
exports.logSpanStart = logSpanStart;

var _debugBuild = require("../debug-build.js");

var _logger = require("../utils-hoist/logger.js");

var _spanUtils = require("../utils/spanUtils.js");

/**
 * Print a log message for a started span.
 */
function logSpanStart(span) {
  if (!_debugBuild.DEBUG_BUILD) return;

  const _spanToJSON = (0, _spanUtils.spanToJSON)(span),
        _spanToJSON$descripti = _spanToJSON.description,
        description = _spanToJSON$descripti === void 0 ? '< unknown name >' : _spanToJSON$descripti,
        _spanToJSON$op = _spanToJSON.op,
        op = _spanToJSON$op === void 0 ? '< unknown op >' : _spanToJSON$op,
        parentSpanId = _spanToJSON.parent_span_id;

  const _span$spanContext = span.spanContext(),
        spanId = _span$spanContext.spanId;

  const sampled = (0, _spanUtils.spanIsSampled)(span);
  const rootSpan = (0, _spanUtils.getRootSpan)(span);
  const isRootSpan = rootSpan === span;
  const header = `[Tracing] Starting ${sampled ? 'sampled' : 'unsampled'} ${isRootSpan ? 'root ' : ''}span`;
  const infoParts = [`op: ${op}`, `name: ${description}`, `ID: ${spanId}`];

  if (parentSpanId) {
    infoParts.push(`parent ID: ${parentSpanId}`);
  }

  if (!isRootSpan) {
    const _spanToJSON2 = (0, _spanUtils.spanToJSON)(rootSpan),
          op = _spanToJSON2.op,
          description = _spanToJSON2.description;

    infoParts.push(`root ID: ${rootSpan.spanContext().spanId}`);

    if (op) {
      infoParts.push(`root op: ${op}`);
    }

    if (description) {
      infoParts.push(`root description: ${description}`);
    }
  }

  _logger.logger.log(`${header}
  ${infoParts.join('\n  ')}`);
}
/**
 * Print a log message for an ended span.
 */


function logSpanEnd(span) {
  if (!_debugBuild.DEBUG_BUILD) return;

  const _spanToJSON3 = (0, _spanUtils.spanToJSON)(span),
        _spanToJSON3$descript = _spanToJSON3.description,
        description = _spanToJSON3$descript === void 0 ? '< unknown name >' : _spanToJSON3$descript,
        _spanToJSON3$op = _spanToJSON3.op,
        op = _spanToJSON3$op === void 0 ? '< unknown op >' : _spanToJSON3$op;

  const _span$spanContext2 = span.spanContext(),
        spanId = _span$spanContext2.spanId;

  const rootSpan = (0, _spanUtils.getRootSpan)(span);
  const isRootSpan = rootSpan === span;
  const msg = `[Tracing] Finishing "${op}" ${isRootSpan ? 'root ' : ''}span "${description}" with ID ${spanId}`;

  _logger.logger.log(msg);
}